import { Link } from 'react-router-dom';
import styles from './MenuModal.module.scss';
import VietnamMap from '~/assets/images/vietnam.png';
import { checkAuthen } from '~/helpers/authen';
import { useState } from 'react';

function MenuModal({ onClickOutside }) {
    const [tripId] = useState(localStorage.getItem('tripId'));
    return (
        <div className={styles.wrapper}>
            <div className={styles.show}>
                <div className={styles.map}>
                    <img src={VietnamMap} alt="Vietnam map" />
                </div>
                <ul className={styles.pages}>
                    {tripId && (
                        <li className={styles.page}>
                            <Link to={'/money'}>
                                <i className="fa-solid fa-sack-dollar"></i>
                                Danh sách chi tiêu
                            </Link>
                        </li>
                    )}
                    {tripId && (
                        <li className={styles.page}>
                            <Link to={'/add'}>
                                <i className="fa-solid fa-dollar-sign"></i>
                                Thêm mới chi tiêu
                            </Link>
                        </li>
                    )}
                    {tripId && (
                        <li className={styles.page}>
                            <Link to={'/place'}>
                                <i className="fa-solid fa-location-dot"></i>
                                QL địa điểm
                            </Link>
                        </li>
                    )}
                    {tripId && (
                        <li className={styles.page}>
                            <Link to={'/stats'}>
                                <i className="fa-solid fa-arrow-up-1-9"></i>
                                Thống kê
                            </Link>
                        </li>
                    )}
                    {checkAuthen() && tripId && (
                        <li className={styles.page}>
                            <div className={styles.separator}></div>
                        </li>
                    )}

                    {checkAuthen() && tripId && (
                        <li className={styles.page}>
                            <Link to={'/trip'}>
                                <i className="fa-solid fa-car"></i>
                                Danh sách chuyến đi
                            </Link>
                        </li>
                    )}
                    {checkAuthen() && (
                        <li className={styles.page}>
                            <Link to={'/logout'}>
                                <i className="fa-solid fa-arrow-right-from-bracket"></i>
                                Đăng xuất
                            </Link>
                        </li>
                    )}

                    {true && (
                        <li className={styles.page}>
                            <div className={styles.separator}></div>
                        </li>
                    )}

                    {true && (
                        <li className={styles.page}>
                            <Link onClick={() => window.location.reload()}>
                                <i className="fa-solid fa-rotate-right"></i>
                                Tải lại App
                            </Link>
                        </li>
                    )}
                </ul>
            </div>
            <div className={styles.notShow} onClick={onClickOutside}></div>
        </div>
    );
}

export default MenuModal;
